module.exports = __webpack_public_path__ + "static/bgAsset-ny-c1981bd1f31e728713198c98f7594992.jpg";